import React from "react";
import PropTypes from "prop-types";

import cn from "./style.module.scss";

export function Confetti(props) {
  const className = `${cn.confetti} ${props.className}`;
  return (
    <div className={className}>
      {Array(13)
        .fill("")
        .map((each, key) => (
          <div key={key} className={cn["confetti-piece"]}></div>
        ))}
    </div>
  );
}

Confetti.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
};

Confetti.defaultProps = {
  className: "",
};
